"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var react_1 = __importDefault(require("react"));
var DesktopTable_1 = __importDefault(require("./DesktopTable"));
var MobileTable_1 = __importDefault(require("./MobileTable"));
var RewardTable = function () {
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    return (react_1.default.createElement("div", null, Object.keys(breakpoints).length > 0 && !breakpoints.mobile ? (react_1.default.createElement(DesktopTable_1.default, null)) : (react_1.default.createElement(MobileTable_1.default, null))));
};
exports.default = RewardTable;
